<script lang="ts">
const itemHeight = 36
</script>
<template>
  <a-spin :spinning="loading">
    <div
      ref="tagsTypeRef"
      :class="[
        bem.b(),
        props.size ? bem.m(props.size) : '',
        props.overflowDisplay === 'wrap' ? bem.is('wrap') : '',
      ]"
    >
      <div ref="tagContainerRef" :class="[bem.e('tag-container')]">
        <template v-for="(item, i) in sortedValue" :key="i">
          <div
            :ref="getTagRefs(i)"
            :class="[
              bem.m('item'),
              !shownArr.includes(item) ? bem.is('hidden') : '',
            ]"
          >
            <div :class="bem.m('text')">
              {{ item }}
            </div>
            <span
              :class="[bem.m('close'), props.disabled ? bem.m('disabled') : '']"
              @click="handleDelByValue(item)"
            >
              <ll-icon
                icon-name="icon-close2"
                :class-name="bem.m('close-icon')"
              />
            </span>
          </div>
        </template>
        <div
          v-if="more > 0"
          ref="moreRef"
          :class="bem.m('more')"
          @mouseenter="handleMoreMouseEnter"
          @mouseleave="handleMoreMouseLeave"
        >
          +{{ more }}
        </div>
        <Teleport to="body">
          <div
            v-if="moreVisible"
            ref="morePopoverRef"
            :class="bem.e('more-popover')"
            :style="morePopoverStyle"
            @mouseenter="handleMorePopoverEnter"
            @mouseleave="handleMorePopoverLeave"
          >
            <div :class="bem.e('arrow')" :style="moreArrowStyle"></div>
            <div :class="bem.e('more-list')">
              <div
                v-for="(item, i) in hiddenTags"
                :key="i"
                :class="bem.e('more-item')"
              >
                <span>{{ item }}</span>
                <ll-icon
                  icon-name="icon-delete"
                  @click.stop="handleDelByValue(item)"
                />
              </div>
            </div>
          </div>
        </Teleport>
        <div :class="bem.e('add-container')">
          <div
            ref="btnRef"
            :class="[
              mouseMove || visible ? bem.is('active') : '',
              bem.m('add-item'),
              props.disabled ? bem.m('disabled') : '',
            ]"
            @click.stop="toggleVisible"
            @mouseover="mouseMove = true"
            @mouseleave="mouseMove = false"
          >
            <ll-icon
              :icon-name="addIcon || 'icon-add'"
              :color="'#666'"
              :class-name="bem.m('add-icon')"
            />
            <span v-if="addText" :class="bem.m('add-text')">{{ addText }}</span>
          </div>
          <Teleport to="body">
            <div
              v-if="visible"
              ref="popoverRef"
              :class="[
                bem.e('popover'),
                exceededMaxTagCount ? bem.m('exceeded') : '',
              ]"
              :style="popoverStyle"
              @click.stop
              @mousedown.stop
            >
              <div :class="bem.e('arrow')" :style="arrowStyle"></div>
              <ll-input
                ref="inputRef"
                v-model:value="inputValue"
                :size="props.size"
                :class="bem.e('search')"
                :is-gray="props.isGray"
                :placeholder="props.placeholder"
                :prefix-icon="`icon-search`"
                @press-enter.prevent="handleEnter"
              />
              <template
                v-if="filterOptionsValue.length > 0 || props.listLoading"
              >
                <div
                  :class="bem.m('select-box-container')"
                  :style="{
                    paddingRight: scrollbarVisible ? '6px' : '12px',
                  }"
                >
                  <div
                    v-if="props.virtual"
                    ref="selectBoxRef"
                    :class="[
                      bem.m('select-box'),
                      !scrollbarVisible ? bem.is('scrollbar-hidden') : '',
                    ]"
                    style="position: relative"
                    @scroll="handleScroll"
                    @mouseenter="handleMouseEnterList"
                    @mouseleave="handleMouseLeaveList"
                  >
                    <div
                      :style="{
                        height: `${totalHeight}px`,
                        width: '100%',
                      }"
                    />
                    <ul
                      :style="{
                        transform: `translateY(${offsetTop}px)`,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                      }"
                    >
                      <li
                        v-for="item in visibleData"
                        :key="item.index"
                        :class="[
                          bem.m('select-item'),
                          value.indexOf(item.value) >= 0 && item.value
                            ? bem.m('select-check')
                            : '',
                        ]"
                        :style="
                          item.isLoader
                            ? 'justify-content: center; margin: 0; width: 100%'
                            : ''
                        "
                        @click="!item.isLoader && handleClickFilter(item.value)"
                      >
                        <span :class="bem.m('select-text')">
                          {{ item.value }}
                        </span>
                        <ll-icon icon-name="icon-check" color="#1890FF" />
                      </li>
                    </ul>
                    <li
                      v-if="props.listLoading"
                      :class="bem.m('select-item')"
                      style="justify-content: center; margin: 0; width: 100%"
                    >
                      <a-spin />
                    </li>
                  </div>
                  <ul
                    v-else
                    ref="selectBoxRef"
                    :class="[
                      bem.m('select-box'),
                      !scrollbarVisible ? bem.is('scrollbar-hidden') : '',
                    ]"
                    @scroll="handleScroll"
                    @mouseenter="handleMouseEnterList"
                    @mouseleave="handleMouseLeaveList"
                  >
                    <li
                      v-for="(item, i) in filterOptionsValue"
                      :key="i"
                      :class="[
                        bem.m('select-item'),
                        value.indexOf(item) >= 0 && item
                          ? bem.m('select-check')
                          : '',
                      ]"
                      @click="handleClickFilter(item)"
                    >
                      <span :class="bem.m('select-text')">
                        {{ item }}
                      </span>
                      <ll-icon icon-name="icon-check" color="#1890FF" />
                    </li>
                    <li
                      v-if="props.listLoading"
                      :class="bem.m('select-item')"
                      style="justify-content: center; margin: 0; width: 100%"
                    >
                      <a-spin />
                    </li>
                  </ul>
                </div>
              </template>

              <div v-else :class="bem.e('empty')">
                <ll-empty :title="props.emptyText" />
              </div>
            </div>
          </Teleport>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { Form } from 'ant-design-vue'
import {
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRef,
  watch,
} from 'vue'
import { tagGroupEmits, tagGroupProps } from './tag-group'

import LlEmpty from '@ll-plus/components/empty'
import type { Ref } from 'vue'

defineOptions({ name: 'LlTagGroup' })

const props = defineProps(tagGroupProps)
const emits = defineEmits(tagGroupEmits)
const bem = createNamespace('tag-group')
// 获取表单项上下文，用于触发表单验证
const formItemContext = Form.useInjectFormItemContext()

const loading = ref(false)
const inputValue = ref('')
const visible = ref(false)
const inputRef = ref()
const more = ref(0) // 超过宽度的标签数量
const mouseMove = ref(false) // 鼠标是否移入添加按钮
const tagsTypeRef = ref<HTMLDivElement | null>(null) // 容器 DOM
const tagContainerRef = ref<HTMLDivElement | null>(null) // 标签容器 DOM
const tagRefs: Ref<HTMLDivElement>[] = reactive([]) // 标签 DOM 数组
const filterOptionsValue = ref<string[]>([]) // 当前展示的选项（会话快照 + 搜索过滤）
const sessionBaseOptions = ref<string[]>([]) // 会话快照：每次打开时初始化，selected 置顶，会话期间保持稳定
const customOptions = ref<string[]>([]) // 自定义过滤后的选项列表
const tagsTypeWidth = ref(0) // 容器宽度
const shownArr = ref<string[]>([]) // 当前显示的标签列表
const btnRef = ref() // 添加按钮 DOM
const popoverRef = ref<HTMLElement>() // 弹窗 DOM
const selectBoxRef = ref<HTMLElement | null>(null) // 选项滚动容器 DOM
const popoverStyle = ref({}) // 弹窗样式
const arrowStyle = ref({}) // 箭头样式
const moreRef = ref<HTMLElement>() // 更多按钮 DOM
const morePopoverRef = ref<HTMLElement>() // 更多弹窗 DOM
const morePopoverStyle = ref({}) // 更多弹窗样式
const moreArrowStyle = ref({}) // 更多箭头样式
const moreVisible = ref(false)
const moreIsHovering = ref(false)
let moreHideTimer: ReturnType<typeof setTimeout> | null = null
let animationFrameId: number | null = null // 动画帧 ID
let moreAnimationFrameId: number | null = null

// 双向绑定值处理，将逗号分隔字符串转换为数组
const value = computed({
  get: () => {
    return props.value
  },
  set: (val: string[]) => {
    emits('update:value', val)
    emits('change', val)
  },
})

const exceededMaxTagCount = computed(() => {
  return props.maxTagCount > 0 && value.value.length >= props.maxTagCount
})

const innerOptions = computed(() => {
  return props.options || []
})

const concatOptions = computed(() => {
  // 自定义新增项置顶，已有选项保持原始顺序不变，value.value 兜底外部已选值
  const set = new Set([
    ...customOptions.value,
    ...innerOptions.value,
    ...value.value,
  ])
  return Array.from(set)
})

// 排序函数，支持中文拼音排序
const sortTags = (tags: string[]) => {
  if (props.sortBy === 'alphabetical') {
    return [...tags].sort((a, b) => {
      // 使用 localeCompare 进行排序，支持中文拼音
      return a.localeCompare(b, 'zh-CN', { sensitivity: 'base' })
    })
  }
  // 默认按添加顺序
  return tags
}

// 排序后的值
const sortedValue = computed(() => {
  return sortTags(value.value)
})

const hiddenTags = computed(() => {
  if (props.overflowDisplay !== 'collapse') return []
  if (shownArr.value.length === 0) return sortedValue.value
  return sortedValue.value.filter((item) => !shownArr.value.includes(item))
})

//获取标签的 DOM 引用
const getTagRefs = (i: number) => {
  return (el: any) => {
    if (el) {
      tagRefs[i] = toRef(el)
    } else {
      tagRefs.splice(i, 1)
    }
  }
}

let resizeObserver: ResizeObserver | null = null

// 计算容器可视宽度
const getWidth = () => {
  if (tagsTypeRef.value) {
    // 减去预留给添加按钮和更多提示的宽度
    tagsTypeWidth.value = tagsTypeRef.value.offsetWidth - 90
  }
}

// 处理回车添加标签
const handleEnter = () => {
  const val = inputValue.value.trim()
  if (!val) return

  // 已达最大标签数：不清空输入、不触发筛选，静默返回
  if (exceededMaxTagCount.value) return

  // 不允许创建且选项中不存在该值：无法添加，不清空输入、不触发筛选
  if (!props.allowCreate && !concatOptions.value.includes(val)) return

  // allowCreate 模式下，若选项中不存在则先添加到选项列表
  if (props.allowCreate && !concatOptions.value.includes(val)) {
    customOptions.value.push(val)
    emits('update:options', concatOptions.value)
    // 直接插入到会话快照头部，不重建列表，滚动位置自然保持
    const prevScrollTop = selectBoxRef.value?.scrollTop ?? 0
    sessionBaseOptions.value = [val, ...sessionBaseOptions.value]
    filterOptionsValue.value = [val, ...filterOptionsValue.value]
    if (prevScrollTop > 0) {
      nextTick(() => {
        const box = selectBoxRef.value
        if (box) {
          box.scrollTop = prevScrollTop + itemHeight
          scrollTop.value = prevScrollTop + itemHeight
        }
      })
    }
  }

  // 切换选中状态
  if (concatOptions.value.includes(val)) {
    const arr = [...value.value]
    const idx = arr.indexOf(val)
    if (idx < 0) {
      arr.push(val)
    } else {
      arr.splice(idx, 1)
    }
    value.value = arr
  }

  inputValue.value = ''
}
const handleFilter = () => {
  // 基于会话快照过滤，保持列表稳定不重排
  if (props.filter && typeof props.filter === 'function' && inputValue.value) {
    filterOptionsValue.value = props.filter(
      inputValue.value,
      sessionBaseOptions.value,
    )
  } else {
    filterOptionsValue.value = sessionBaseOptions.value
  }
}

// 删除标签
// 移除自定义选项（同步从 customOptions / sessionBaseOptions / filterOptionsValue 中删除）
const removeCustomOption = (item: string) => {
  if (!customOptions.value.includes(item)) return
  customOptions.value = customOptions.value.filter((o) => o !== item)
  sessionBaseOptions.value = sessionBaseOptions.value.filter((o) => o !== item)
  filterOptionsValue.value = filterOptionsValue.value.filter((o) => o !== item)
  emits('update:options', concatOptions.value)
}

const handleDelByValue = (tag: string) => {
  if (!tag) return
  removeCustomOption(tag)
  value.value = value.value.filter((e) => e !== tag)
}

// 点击下拉选项过滤
const handleClickFilter = (item: string) => {
  let arr = [...value.value]
  if (arr.indexOf(item) >= 0) {
    arr = arr.filter((e) => e !== item)
    value.value = arr
    removeCustomOption(item)
  } else {
    // 检查是否超过最大标签数
    if (exceededMaxTagCount.value) {
      return
    }
    arr.push(item)
    value.value = arr
  }
  inputValue.value = ''
}

// 虚拟列表相关

const scrollTop = ref(0) // 记录滚动高度
const totalHeight = computed(() => {
  return (
    filterOptionsValue.value.length * itemHeight +
    (props.listLoading ? itemHeight : 0)
  )
})
const visibleData = computed(() => {
  const totalCount =
    filterOptionsValue.value.length + (props.listLoading ? 1 : 0)
  const visibleCount = Math.ceil(180 / itemHeight) + 4 // 可见行数 + 缓冲区

  // 防止异步数据更新后 scrollTop 过时导致 start 超出范围（此时 visibleData 会变成空数组）
  let start = Math.floor(scrollTop.value / itemHeight)
  if (totalCount > 0 && start >= totalCount) {
    start = Math.max(0, totalCount - visibleCount)
  }

  const end = Math.min(start + visibleCount, totalCount)
  const result: any[] = []
  for (let i = start; i < end; i++) {
    const isLoader = i === filterOptionsValue.value.length && props.listLoading
    result.push({
      index: i,
      value: isLoader ? '' : filterOptionsValue.value[i],
      isLoader,
    })
  }
  return result
})
const offsetTop = computed(() => {
  if (visibleData.value.length === 0) return 0
  return visibleData.value[0].index * itemHeight
})

const scrollbarVisible = ref(false)
const isHovering = ref(false)
let scrollTimer: any = null

const showScrollbar = () => {
  scrollbarVisible.value = true
  if (scrollTimer) clearTimeout(scrollTimer)
}

const hideScrollbarWithDelay = () => {
  if (scrollTimer) clearTimeout(scrollTimer)
  scrollTimer = setTimeout(() => {
    if (!isHovering.value) {
      scrollbarVisible.value = false
    }
  }, 3000)
}

const handleMouseEnterList = () => {
  isHovering.value = true
  showScrollbar()
}

const handleMouseLeaveList = () => {
  isHovering.value = false
  hideScrollbarWithDelay()
}

const handleScroll = (e: Event) => {
  const target = e.target as HTMLElement
  scrollTop.value = target.scrollTop
  const { clientHeight, scrollHeight } = target
  // 滚动到离底部 triggerDistance 高度时触发 scroll-bottom
  if (target.scrollTop + clientHeight >= scrollHeight - props.triggerDistance) {
    emits('scroll-bottom')
  }
  showScrollbar()
  hideScrollbarWithDelay()
}

// 更新弹窗位置
const updatePosition = () => {
  if (!visible.value || !btnRef.value || !popoverRef.value) {
    if (animationFrameId !== null) {
      // 如果不再显示，可以停止循环，但通常 watch 会处理
    }
    // 如果没有显示或者没有 ref，尝试下一帧（如果在显示中的话）
    if (visible.value) animationFrameId = requestAnimationFrame(updatePosition)
    return
  }
  const rect = btnRef.value.getBoundingClientRect()
  const popRect = popoverRef.value.getBoundingClientRect()

  // 计算位置，使得弹窗中心对齐按钮中心
  let left = rect.left + rect.width / 2 - popRect.width / 2
  const top = rect.bottom + 12

  // 简单的边界处理
  if (left < 10) left = 10
  if (left + popRect.width > window.innerWidth - 10) {
    left = window.innerWidth - popRect.width - 10
  }
  // 防止超出底部 (可选)
  // if (top + popRect.height > window.innerHeight) top = rect.top - popRect.height - 12

  popoverStyle.value = {
    position: 'fixed',
    left: `${left}px`,
    top: `${top}px`,
    zIndex: 2000,
  }
  // 箭头位置计算
  const btnCenter = rect.left + rect.width / 2
  const arrowLeft = btnCenter - left
  arrowStyle.value = {
    left: `${arrowLeft}px`,
  }
  animationFrameId = requestAnimationFrame(updatePosition)
}

const updateMorePosition = () => {
  if (!moreVisible.value || !moreRef.value || !morePopoverRef.value) {
    if (moreVisible.value) {
      moreAnimationFrameId = requestAnimationFrame(updateMorePosition)
    }
    return
  }
  const rect = moreRef.value.getBoundingClientRect()
  const popRect = morePopoverRef.value.getBoundingClientRect()

  let left = rect.left + rect.width / 2 - popRect.width / 2
  const top = rect.bottom + 12

  if (left < 10) left = 10
  if (left + popRect.width > window.innerWidth - 10) {
    left = window.innerWidth - popRect.width - 10
  }

  morePopoverStyle.value = {
    position: 'fixed',
    left: `${left}px`,
    top: `${top}px`,
    zIndex: 2000,
  }
  const btnCenter = rect.left + rect.width / 2
  const arrowLeft = btnCenter - left
  moreArrowStyle.value = {
    left: `${arrowLeft}px`,
  }
  moreAnimationFrameId = requestAnimationFrame(updateMorePosition)
}

const toggleVisible = () => {
  visible.value = !visible.value
}

const handleClickOutside = (e: Event) => {
  if (!visible.value) return
  const target = e.target as HTMLElement
  // 判断点击是否在弹窗内部或按钮上
  if (
    (popoverRef.value && popoverRef.value.contains(target)) ||
    (btnRef.value && btnRef.value.contains(target))
  ) {
    return
  }
  visible.value = false
}

const showMorePopover = () => {
  if (props.overflowDisplay !== 'collapse') return
  if (hiddenTags.value.length === 0) return
  moreVisible.value = true
  if (moreHideTimer) {
    clearTimeout(moreHideTimer)
    moreHideTimer = null
  }
  nextTick(() => {
    updateMorePosition()
  })
}

const hideMorePopoverImmediate = () => {
  moreVisible.value = false
  if (moreHideTimer) {
    clearTimeout(moreHideTimer)
    moreHideTimer = null
  }
  if (moreAnimationFrameId !== null) {
    cancelAnimationFrame(moreAnimationFrameId)
    moreAnimationFrameId = null
  }
}

const hideMorePopoverWithDelay = () => {
  if (moreHideTimer) clearTimeout(moreHideTimer)
  moreHideTimer = setTimeout(() => {
    if (!moreIsHovering.value) {
      moreVisible.value = false
      if (moreAnimationFrameId !== null) {
        cancelAnimationFrame(moreAnimationFrameId)
        moreAnimationFrameId = null
      }
    }
  }, 150)
}

const handleMoreMouseEnter = () => {
  moreIsHovering.value = true
  showMorePopover()
}

const handleMoreMouseLeave = () => {
  moreIsHovering.value = false
  hideMorePopoverWithDelay()
}

const handleMorePopoverEnter = () => {
  moreIsHovering.value = true
  showMorePopover()
}

const handleMorePopoverLeave = () => {
  moreIsHovering.value = false
  hideMorePopoverWithDelay()
}

// 监听 Popover 显示状态：打开时初始化会话快照（已选项置顶），关闭时清理
watch(visible, (val) => {
  if (val) {
    scrollTop.value = 0
    // 构建会话快照：已选项（排序后）置顶，其余选项保持原始顺序
    const all = concatOptions.value
    const selectedSet = new Set(value.value)
    const selected = sortTags(all.filter((i) => selectedSet.has(i)))
    const unselected = all.filter((i) => !selectedSet.has(i))
    sessionBaseOptions.value = [...selected, ...unselected]
    filterOptionsValue.value = sessionBaseOptions.value
    window.addEventListener('mousedown', handleClickOutside)
    nextTick(() => {
      updatePosition()
      if (selectBoxRef.value) {
        selectBoxRef.value.scrollTop = 0
      }
      setTimeout(() => {
        inputRef.value?.focus()
      }, 100)
    })
  } else {
    inputValue.value = ''
    window.removeEventListener('mousedown', handleClickOutside)
    if (animationFrameId !== null) {
      cancelAnimationFrame(animationFrameId)
      animationFrameId = null
    }
  }
})

watch(
  [filterOptionsValue, () => props.listLoading],
  () => {
    if (!visible.value) return
    // 立即用数据长度修正 scrollTop.value，保证 visibleData 能在当前 tick 计算出有效结果
    const maxScrollTopByData = Math.max(
      0,
      (filterOptionsValue.value.length + (props.listLoading ? 1 : 0) - 1) *
        itemHeight,
    )
    if (scrollTop.value > maxScrollTopByData) {
      scrollTop.value = maxScrollTopByData
    }
    // nextTick 后再与 DOM 实际 scrollTop 对齐
    nextTick(() => {
      const box = selectBoxRef.value
      if (!box) return
      const maxScrollTop = Math.max(0, box.scrollHeight - box.clientHeight)
      if (box.scrollTop > maxScrollTop) {
        box.scrollTop = maxScrollTop
      }
      scrollTop.value = box.scrollTop
    })
  },
  { deep: true },
)

watch(
  [
    () => props.overflowDisplay,
    () => more.value,
    () => hiddenTags.value.length,
  ],
  () => {
    if (props.overflowDisplay !== 'collapse' || more.value <= 0) {
      hideMorePopoverImmediate()
      return
    }
    if (hiddenTags.value.length === 0) {
      hideMorePopoverImmediate()
    }
  },
)

// 监听外部选项变化（异步加载场景）：弹窗打开期间合并新数据到会话快照并重新过滤
watch(
  () => props.options,
  (newOpts) => {
    if (!visible.value) return
    const incoming = newOpts || []
    // 用 Set 构建最终快照，彻底避免任何来源的重复：
    // 1. 保留旧快照中仍然有效的项（已选 / 自定义 / 仍在新选项中）
    // 2. 追加新增项（incoming 中快照里没有的）
    // 全部通过 Set 去重后转回数组
    const allKnown = new Set([
      ...value.value,
      ...customOptions.value,
      ...incoming,
    ])
    const kept = sessionBaseOptions.value.filter((item) => allKnown.has(item))
    const keptSet = new Set(kept)
    // 用 Set 对 added 自身也去重，防止 incoming 本身含重复项
    const addedSet = new Set(incoming.filter((item) => !keptSet.has(item)))
    sessionBaseOptions.value = [...kept, ...addedSet]
    handleFilter()
  },
  { deep: true },
)

// 监听值变化和容器宽度变化，计算需要折叠的标签
watch(
  [
    () => value.value.length,
    tagsTypeWidth,
    () => props.sortBy,
    () => props.overflowDisplay,
    () => props.collapseThreshold,
  ],
  async (n, o) => {
    await nextTick()

    // 触发 FormItem 的校验
    const checkValidate = () => {
      if (o && o[0]) {
        if (n[0] !== o[0]) {
          formItemContext.onFieldChange()
          formItemContext.onFieldBlur()
        }
      }
    }

    if (props.overflowDisplay === 'wrap') {
      shownArr.value = sortedValue.value
      more.value = 0
      checkValidate()
      return
    }

    if (props.overflowDisplay === 'collapse' && props.collapseThreshold > 0) {
      const sorted = sortedValue.value
      shownArr.value = sorted.slice(0, props.collapseThreshold)
      const diff = sorted.length - props.collapseThreshold
      more.value = diff > 0 ? diff : 0
      checkValidate()
      return
    }

    const arr: string[] = []
    let moreLeftValue = 0
    const sorted = sortedValue.value
    // 遍历计算每个标签的宽度是否超出容器
    for (let i = 0; i < sorted.length; i++) {
      // 边界检查：元素可能未挂载
      const tagEl = tagRefs[i]?.value
      if (!tagEl) continue

      const targetWidth = tagEl.offsetWidth + 10 // 加上间距

      if (moreLeftValue + targetWidth >= n[1]) {
        break
      } else {
        moreLeftValue += targetWidth
        arr.push(sorted[i])
      }
    }

    // 更新剩余数量
    const diff = n[0] - arr.length
    more.value = diff > 0 ? diff : 0

    shownArr.value = arr

    checkValidate()
  },
  {
    deep: true,
    immediate: true,
  },
)

watch(inputValue, () => {
  emits('input', inputValue.value)
  handleFilter()
})

// 生命周期：挂载 ResizeObserver
onMounted(() => {
  nextTick(() => {
    // 确保初始计算正确，尤其是在组件初始时可能存在的布局变化
    getWidth()
  })
  if (tagsTypeRef.value) {
    resizeObserver = new ResizeObserver(getWidth)
    resizeObserver.observe(tagsTypeRef.value)
  }
})

// 生命周期：清理 ResizeObserver
onUnmounted(() => {
  resizeObserver?.disconnect()
  resizeObserver = null
  window.removeEventListener('mousedown', handleClickOutside)
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
    animationFrameId = null
  }
  hideMorePopoverImmediate()
})
</script>
